<template>
  <v-container
    id="home"
    fluid
    tag="section"
    style="height: auto;padding-top: 1px !important;"
  >
  </v-container>
</template>

<script>
  export default {
    name: 'Home',
    components: {
    },
    data () {
      return {
        taskDialog: null,
      }
    },
    watch: {
    },
    mounted () {
    },
    methods: {
    },
  }
</script>
